import { useState } from "react";
import useErrorLogger from "@/utils/useErrorLogger";
import { Provider } from "../providerSection";
import { Service } from "./types";

type Props = {
  availableProviders: Provider[];
  services: Service[];
  onUpdateServiceProvider: (index: number, provider: Provider) => void;
};

export const useSelectServiceProviderModal = ({
  availableProviders,
  services,
  onUpdateServiceProvider,
}: Props) => {
  const logError = useErrorLogger();
  const [modalOpen, setModalOpen] = useState(false);
  const [eligibleProviders, setEligibleProviders] = useState<Provider[]>([]);
  const [selectedProviderId, setSelectedProviderId] = useState("");
  const [editedServiceIndex, setEditedServiceIndex] = useState(-1);
  const serviceName =
    editedServiceIndex != -1
      ? services[editedServiceIndex].serviceMenuItem.name
      : "";

  const openSelectProviderModal = (serviceIndex: number) => {
    const service = services[serviceIndex];
    const eligibleProviderUserMedspaIds =
      service.serviceMenuItem.eligibleProviders.map(
        (eligibleProvider) => eligibleProvider.userMedspa.id
      );

    const eligibleProviders = availableProviders.filter((providerUserMedspa) =>
      eligibleProviderUserMedspaIds.includes(providerUserMedspa.id)
    );
    setModalOpen(true);
    setEligibleProviders(eligibleProviders);
    setSelectedProviderId(service.provider.id);
    setEditedServiceIndex(serviceIndex);
  };

  const closeSelectProviderModal = () => {
    setModalOpen(false);
    setEligibleProviders([]);
    setSelectedProviderId("");
    setEditedServiceIndex(-1);
  };

  const updateProviderForService = () => {
    const provider = eligibleProviders.find(
      (provider) => provider.id === selectedProviderId
    );
    if (!provider) {
      logError(
        new Error(
          `[useSelectServiceProviderModal] Cannot find provider with id ${selectedProviderId} from eligible providers of service ${serviceName}`
        )
      );

      return;
    }
    onUpdateServiceProvider(editedServiceIndex, provider);
    closeSelectProviderModal();
  };

  return {
    isModalOpened: modalOpen,
    eligibleProviders,
    selectedProviderId,
    serviceName,
    selectProviderId: setSelectedProviderId,
    openSelectProviderModal,
    closeSelectProviderModal,
    updateProviderForService,
  };
};
